<form [formGroup]="formGroupAccountType">
  <h2>Account Type</h2>
  <div class="account-type__container account-type__container--with-wizard-buttons">
    <p>I want to create an account of the following type:</p>
    <mat-radio-group
      class="account-type__radio-group"
      formControlName="accountType"
      (change)="onAccountTypeChange($event.value)"
      aria-label="Select an option"
    >
      <mat-radio-button [value]="NewAccountType.Prs">Premium Rate Services</mat-radio-button>
      <mat-radio-button [value]="NewAccountType.Radio">Radio Spectrum Licensing</mat-radio-button>
    </mat-radio-group>
    @if (formGroupAccountType.invalid && (formGroupAccountType.dirty || formGroupAccountType.touched)) {
      <span class="account-type__error-message"> You must select an account type</span>
    }
  </div>
</form>
